import { BaseEntity } from '../base-entity';

export class FormPc003Filter extends BaseEntity {
    contrato_juridico: string;
    hibrido_rnc: string;
    especie: string;
    safra: string;
    ano: string;
    geracao: string;
    site_origem: string;
}
